import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../hooks'
import { FlatSelect } from '../../Flat'
import { FormFieldSelectNG } from '../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import {
  LISTING_FORM_FIELD_NAME_BUILDING,
  LISTING_FORM_FIELD_NAME_FLAT,
} from '../RentalPortalListing.constants'

import {
  getHasListingFlatOutsideBuilding,
  getListingFlatPlaceholderKey,
  getListingFlatSearchApiParams,
  toListingFlatSearchSelectItems,
} from './RentalPortalListingFlatField.utils'
import { RentalPortalListingFlatFieldSelectDropdownEmpty } from './RentalPortalListingFlatFieldSelectDropdownEmpty'
import { RentalPortalListingFlatFieldWithFacts } from './RentalPortalListingFlatFieldWithFacts'

function RentalPortalListingFlatField({
  FieldComponent,
  borderless,
  disabled,
  isLoading,
}) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  const building = values[LISTING_FORM_FIELD_NAME_BUILDING]?.value

  function handlePrepareItems(items) {
    return toListingFlatSearchSelectItems({ items, t })
  }

  function handleChangeFlat(value) {
    if (getHasListingFlatOutsideBuilding({ building, flat: value?.flat })) {
      setFieldValue(LISTING_FORM_FIELD_NAME_BUILDING, null)
    }
  }

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={RentalPortalListingFlatFieldWithFacts}
      Select={FlatSelect}
      apiParams={getListingFlatSearchApiParams(building)}
      controlProps={{
        borderless: borderless ?? !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t(getListingFlatPlaceholderKey(building)),
          },
        },
      }}
      disabled={disabled}
      emptyValue={null}
      fieldComponentProps={{
        FieldComponent,
        flat: values[LISTING_FORM_FIELD_NAME_FLAT]?.flat,
        info: disabled
          ? t('RentalPortal.ListingAddressDraftOnlyTooltipKey')
          : undefined,
        isLoading,
        label: `${t('RentalPortal.ListingFormFlatLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      listProps={{ Empty: RentalPortalListingFlatFieldSelectDropdownEmpty }}
      name={LISTING_FORM_FIELD_NAME_FLAT}
      toPreparedItems={handlePrepareItems}
      onChange={handleChangeFlat}
    />
  )
}

export default RentalPortalListingFlatField
